var map = {
	"./apple-logo.svg": 305168,
	"./apple-pay.svg": 456704,
	"./approved-pay.svg": 62704,
	"./credit-card.svg": 943044,
	"./credit-cards.svg": 956932,
	"./money-icon.png": 907196,
	"./reject-pay.svg": 57180,
	"./wire-transfer.svg": 4860
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 271824;